const CombinationData = [
    {
        "id": 1,
        "type1": "비타민A",
        "type2": "아연",
        "title": '"적절함"',
        "explain": "아연이 비타민 A가 혈액 속에서 일정한 농도를 유지하며 필요한 곳에 고루 분포되도록 돕습니다. 비타민 A를 꾸준히 섭취해도 아연이 부족한 경우 결핍현상이 나타나므로 함께 복용하는 것이 좋습니다."
    },
    {
        "id": 2,
        "type1": "비타민A",
        "type2": "비타민D",
        "title": '"부적절함"',
        "explain": "지용성 비타민인 A와 D는 같이 복용할 경우 흡수를 방해할 수 있다. 두 비타민의 성분이 모두 필요한 경우, 비타민A는 영양제가 아닌 식품을 통해 섭취하는 것을 추천드립니다."
    },
    {
        "id": 3,
        "type1": "비타민A",
        "type2": "루테인",
        "title": '"부적절함"',
        "explain": "루테인이 비타민A의 일종이기 때문에 비타민A와 루테인을 모두 고함량으로 섭취하면 비타민A 과잉 상태가 될 수 있습니다. 비타민A 과잉 상태가 되면 구토, 두통, 설사 증상이 나타날 수 있습니다."
    },
    {
        "id": 4,
        "type1": "비타민B1",
        "type2": "아연",
        "title": '"적절함"',
        "explain": "비타민 B가 아연의 흡수를 증가시키는 데 도움을 줍니다."
    },
    {
        "id": 5,
        "type1": "비타민C",
        "type2": "철분제",
        "title": '"적절함"',
        "explain": "비타민 C가 철분의 흡수를 증가시키는 데 도움을 줍니다."
    },
    {
        "id": 6,
        "type1": "비타민D",
        "type2": "칼슘",
        "title": '"부적절함"',
        "explain": "체내에서 칼슘 흡수가 과해져 고칼슘혈증을 유발할 수 있습니다. 칼슘 성분이 지나치면 혈관이 딱딱해지기도 해, 동맥 경화나 이상지질혈증이 있는 사람은 특히 조심해야 합니다."
    },
    {
        "id": 7,
        "type1": "비타민D",
        "type2": "마그네슘",
        "title": '"적절함"',
        "explain": "비타민D는 비활성형태에서 제기능을 하지 못해 활성형태로 변환해야 하는데, 이때 마그네슘이 크게 관여하여 비타민D가 제대로 효과를 발휘하도록 돕습니다."
    },
    {
        "id": 8,
        "type1": "비타민D",
        "type2": "오메가3",
        "title": '"적절함"',
        "explain": "오메가3의 기음이 지용성인 비타민D에 잘 녹기 때문에 위장에서 안정적인 흡수를 촉진시킵니다. 또한 면역억제 및 항염증 효과로 자가면역질환의 발생 위험을 줄여줍니다."
    },
    {
        "id": 9,
        "type1": "루테인",
        "type2": "아연",
        "title": '"부적절함"',
        "explain": "루테인의 흡수율이 감소할 수 있습니다. 최소 2시간의 시간차를 두고 섭취하시길 바랍니다."
    },
    {
        "id": 10,
        "type1": "루테인",
        "type2": "칼슘",
        "title": '"부적절함"',
        "explain": "루테인의 흡수율이 감소할 수 있습니다. 최소 2시간의 시간차를 두고 섭취하시길 바랍니다."
    },
    {
        "id": 11,
        "type1": "루테인",
        "type2": "마그네슘",
        "title": '"부적절함"',
        "explain": "루테인은 지용성 영양소이기에 기름에 섞여서 지방이 소화되면서 몸속으로 흡수가 됩니다. 마그네슘 같은 금속성 이온들은 이런 지용성 영양소가 지방에 섞여 소화되는 과정을 방해합니다. 따라서 같이 복용 시 루테인의 흡수율은 줄어들게 됩니다."
    },
    {
        "id": 12,
        "type1": "루테인",
        "type2": "철분제",
        "title": '"부적절함"',
        "explain": "루테인의 흡수율이 감소할 수 있습니다. 최소 2시간의 시간차를 두고 섭취하시길 바랍니다."
    },
    {
        "id": 13,
        "type1": "칼슘",
        "type2": "아연",
        "title": '"부적절함"',
        "explain": "아연과 칼슘은 상호 경쟁적으로 소장에서 흡수되는데, 고용량 아연의 경우 소장에서 칼슘 흡수를 억제합니다."
    },
    {
        "id": 14,
        "type1": "칼슘",
        "type2": "철분제",
        "title": '"부적절함"',
        "explain": "서로 흡수를 방해함으로 최소 2시간 이상의 시간차를 두고 섭취하시길 바랍니다."
    },
    {
        "id": 15,
        "type1": "마그네슘",
        "type2": "아연",
        "title": '"부적절함"',
        "explain": "고용량 아연 보충제를 복용하는 경우, 아연이 마그네슘 흡수를 억제할 수 있으며, 이로 인해 마그네슘 결핍이 발생할 수 있습니다."
    },
    {
        "id": 16,
        "type1": "마그네슘",
        "type2": "철분제",
        "title": '"부적절함"',
        "explain": "철분의 흡수율이 감소할 수 있습니다. 시간차를 두어 아침 식전에 철분을 복용하고, 마그네슘은 저녁 식사 후에 섭취하시길 바랍니다."
    },
    {
        "id": 17,
        "type1": "마그네슘",
        "type2": "오메가3",
        "title": '"부적절함"',
        "explain": "서로 흡수를 방해함으로 최소 2시간 이상의 시간차를 두고 섭취하시길 바랍니다."
    },
    {
        "id": 18,
        "type1": "마그네슘",
        "type2": "오메가3",
        "title": '"부적절함"',
        "explain": "서로 흡수를 방해함으로 최소 2시간 이상의 시간차를 두고 섭취하시길 바랍니다."
    },
    {
        "id": 19,
        "type1": "철분제",
        "type2": "아연",
        "title": '"부적절함"',
        "explain": "흡수되는 경로가 같아서 서로의 흡수를 방해할 수 있습니다. 최소 2시간 이상의 시간차를 두고 섭취하시길 바랍니다."
    },
]

export default CombinationData